import { render, staticRenderFns } from "./ticketlist.vue?vue&type=template&id=14cc970b&"
import script from "./ticketlist.vue?vue&type=script&lang=js&"
export * from "./ticketlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports